import type { AppConfig } from '../services/config';

/**
 * Local / `main` / `dev` branch — development build configuration.
 * `main` and `dev` share this config (per the deploy model).
 *
 * Points at the deployed **dev** backend + Cognito (us-east-1). The API host exposes four
 * versioned base paths (`/crm/v1`, `/sub/v1`, `/client/v1`, `/public/v1`); `apiBaseUrl` is
 * the CRM base and the sub/client/public bases derive from it (see `ConfigService`).
 *
 * `mockAuth` is OFF: the login page uses real Cognito sign-in against the dev pool. To do
 * pure local UI work without the backend, flip this to `true` locally (do not commit).
 */
export const VANTAGE_APP_CONFIG: AppConfig = {
  apiBaseUrl: 'https://api.dev.vantageworks.ai/crm/v1',
  subApiBaseUrl: 'https://api.dev.vantageworks.ai/sub/v1',
  clientApiBaseUrl: 'https://api.dev.vantageworks.ai/client/v1',
  publicApiBaseUrl: 'https://api.dev.vantageworks.ai/public/v1',
  cognitoUserPoolId: 'us-east-1_WsBMyJ6UH',
  cognitoClientId: '7mvn0plkmh4s2sc37q7fl0u4r2',
  cognitoRegion: 'us-east-1',
  mockAuth: false,
  // TEMP(dev): skip the forced-TOTP-enrollment gate so 2FA isn't prompted during development.
  // No MFA code is removed — flip back to false to re-enable. (Keep dev users un-enrolled so
  // Cognito itself doesn't issue a TOTP challenge.)
  skipMfa: true,
};
